<!-- src/components/ChatHistory.vue -->
<template>
  <div v-if="chatHistory.length" class="chat-history">
    <div v-for="(message, index) in chatHistory" :key="index">
      <div v-if="message.role === 'user'" class="user-message">
        <strong>Sie:</strong> {{ message.content }}
      </div>
      <div v-else-if="message.role === 'assistant'" class="assistant-message">
        <strong>Assistent:</strong> {{ message.content }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatHistory',
  props: {
    chatHistory: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.chat-history {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
}

.user-message {
  text-align: right;
  background-color: #e3f2fd;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.assistant-message {
  text-align: left;
  background-color: #f1f1f1;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 8px;
}
</style>